import { Observable } from 'rxjs';
import type {
  ContractDefinition,
  ContractDefinitionCreatedInfo,
  ContractDefinitionDeletedInfo,
  ContractDefinitionUpdatedInfo
} from '../models/contract-definition.model';

/**
 * Stable domain contract for contract-definition CRUD operations.
 * Implemented by AdessoContractDefinitionApiAdapter against the adesso-connector-api.
 */
export abstract class ContractDefinitionApiPort {
  abstract getContractDefinitions(): Observable<ContractDefinition[]>;
  abstract createContractDefinition(
    contractDefinition: ContractDefinition
  ): Observable<ContractDefinitionCreatedInfo>;
  abstract updateContractDefinition(
    contractDefinition: ContractDefinition
  ): Observable<ContractDefinitionUpdatedInfo>;
  abstract deleteContractDefinition(id: string): Observable<ContractDefinitionDeletedInfo>;
}
